<template>
  <settings-modal
    class="payment-accept-modal t-payment-accept-modal"
  >
    <div
      v-if="profileApiRequest.loading"
      class="payment-accept-modal__loader"
    >
      <v-progress-circular
        indeterminate
        color="primary"
      />
    </div>
    <template v-else>
      <template slot="heading">
        <span
          v-if="isRecipientProfileClosed"
          class="red--text font-weight-bold t-modal-title"
        >{{ `Are you sure to accept payment ${payment.id} to closed account?` }}</span>

        <span
          v-else
          class="t-modal-title"
        >{{ `Accept payment ${payment.id}?` }}</span>
      </template>

      <p
        v-if="isChannelMessageVisible"
        class="subheading red--text text-darken-2 mb-0"
      >The customer does not have the channel <b>{{ payment.channel | optionName(channelOptions) }}</b>.</p>

      <error-alert :error="error" />

      <template slot="actions">
        <v-btn
          id="accept"
          :color="isRecipientProfileClosed ? 'red white--text' : 'primary'"
          medium
          flat
          :disabled="loading"
          @click="onConfirmButtonClick"
        >confirm</v-btn>

        <v-btn
          class="t-close-modal"
          color="primary"
          medium
          flat
          @click="onCloseButtonClick"
        >close</v-btn>
      </template>
    </template>
  </settings-modal>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  // Models
  import Payment from '@/models/Payment'
  import Profile from '@/models/AccountProfile'

  // Events
  import { EVENT_PAYMENT_UPDATE } from '@/events/payments'

  // Services
  import ApiRequest from '@/services/ApiRequests/ApiRequest'
  import PaymentApi from '@/services/Api/PaymentApi'
  import ProfileApi from '@/services/Api/ProfileApi'

  // Components
  import SettingsModal from '@/components/modals/SettingsModal'
  import ErrorAlert from '@/components/ui/ErrorAlert'

  export default {
    name: 'PaymentAcceptModal',
    components: {
      SettingsModal,
      ErrorAlert
    },
    data () {
      return {
        acceptByAmlApiRequest: new ApiRequest(PaymentApi.acceptByAml),
        profileApiRequest: new ApiRequest(ProfileApi.fetchById, Profile)
      }
    },
    computed: {
      ...mapGetters('modal', ['modal']),
      isRecipientProfileClosed () {
        return this.recipientProfile != null && this.recipientProfile.isClosed
      },
      payment () {
        return this.modal.data.payment
      },
      recipientAccount () {
        return this.modal.data.recipientAccount
      },
      recipientProfile () {
        return this.profileApiRequest.data
      },
      loading () {
        return this.acceptByAmlApiRequest.loading
      },
      error () {
        return this.acceptByAmlApiRequest.error || this.profileApiRequest.error
      },
      channelOptions () {
        return Payment.channelOptions
      },
      isChannelMessageVisible () {
        if (this.recipientAccount == null || this.payment.channel == null) {
          return false
        }

        return !this.recipientAccount.allowedIncomingChannels.includes(this.payment.channel)
      }
    },
    created () {
      if (this.payment.recipientProfileId != null) {
        this.profileApiRequest.execute(this.payment.recipientProfileId).catch(() => {})
      }
    },
    methods: {
      ...mapActions('modal', ['showModal', 'closeModal']),
      onConfirmButtonClick () {
        this.acceptByAmlApiRequest
          .execute(this.payment.id)
          .then(this.acceptByAmlSuccessHandler)
          .catch(() => {})
      },
      onCloseButtonClick () {
        this.closeModal()
      },
      acceptByAmlSuccessHandler () {
        this.$eventHub.$emit(EVENT_PAYMENT_UPDATE)
        this.closeModal()

        setTimeout(() => {
          this.showModal({
            name: 'SuccessFlashModal',
            data: { message: 'Payment has been successfully accepted.' }
          })
        }, 100)
      }
    }
  }
</script>

<style lang="scss">
  .payment-accept-modal {
    &__loader {
      display: flex;
      justify-content: center;
      margin-bottom: 20px;
    }
  }
</style>
